import React from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

export interface LabeledValue {
  name: string;
  value: string;
}
export interface LabeledValuesProps {
  labeledValues: Array<LabeledValue>;
  darkMode?: boolean;
}

const LabeledValues = ({ labeledValues, darkMode }: LabeledValuesProps) => {
  return (
    <dl className="tw-grid tw-grid-cols-[repeat(2,auto)] tw-order-2 tw-gap-y-2 tw-gap-x-8 tw-items-baseline tw-justify-center tw-justify-items-start tw-text-left lg:tw-flex lg:tw-gap-0">
      {labeledValues?.map(({ name, value }) => {
        return (
          <React.Fragment key={`${name}-${value}`}>
            <dt
              className={classNames(
                'tw-mb-0 tra-text-web-utl-label-l tw-normal-case tw-tracking-normal',
                darkMode ? 'tw-text-surface-400' : 'tw-text-text-500',
              )}
            >
              {name}
            </dt>
            <dd
              className={classNames(
                'lg:tw-pl-4 lg:tw-pr-10 lg:last-of-type:tw-pr-0 tw-mb-0',
                darkMode ? 'tw-text-surface-100' : 'tw-text-text-300',
              )}
            >
              {value}
            </dd>
          </React.Fragment>
        );
      })}
    </dl>
  );
};

export default LabeledValues;
